<portal-root>
  <div
    class="loader"
    loader></div>
  <al-logo logo />
</portal-root>
